import { axios } from "../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";
import { useGeneralAppStore } from "../store/generalAppStore";
import { useLocation } from "react-router-dom";

const { handlerLoading, handlerModal } = useGeneralAppStore.getState();

//TODO trae estadisticas generales de las infracciones
export const getEstadisticasGeneral = async () => {
  handlerLoading({ loading: true, loadName: "estadisticas" });
  // handlerLoading({ loading: true, loadName: "get_estadisticas" });
  // handlerLoading({ loading: true, loadName: "estadisticas_vehiculos" });
  try {
    const response = await axios().get("/get_estadisticas_general");
    // handlerLoading({ loading: false, loadName: "estadisticas" });
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "estadisticas" });
    // handlerLoading({ loading: false, loadName: "get_estadisticas" });
    // handlerLoading({ loading: false, loadName: "estadisticas_vehiculos" });
  }
};
export const getEstadisticasInfraccionesSemaforos = async () => {
  handlerLoading({ loading: true, loadName: "estadisticas_semaforo" });
  // handlerLoading({ loading: true, loadName: "get_estadisticas" });
  // handlerLoading({ loading: true, loadName: "estadisticas_vehiculos" });
  try {
    const response = await axios().get("/get_estadisticas_semaforo");
    // handlerLoading({ loading: false, loadName: "estadisticas" });
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "estadisticas_semaforo" });
    // handlerLoading({ loading: false, loadName: "get_estadisticas" });
    // handlerLoading({ loading: false, loadName: "estadisticas_vehiculos" });
  }
};
export const getEstadisticasTipo = async () => {
  handlerLoading({ loading: true, loadName: "estadisticas_tipo" });
  // handlerLoading({ loading: true, loadName: "get_estadisticas" });
  // handlerLoading({ loading: true, loadName: "estadisticas_vehiculos" });
  try {
    const response = await axios().get("/get_estadisticas_tipo");
    // handlerLoading({ loading: false, loadName: "estadisticas" });
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "estadisticas_tipo" });
    // handlerLoading({ loading: false, loadName: "get_estadisticas" });
    // handlerLoading({ loading: false, loadName: "estadisticas_vehiculos" });
  }
};
export const getEstadisticasAbonadas = async () => {
  handlerLoading({ loading: true, loadName: "estadisticas_abonadas" });
  // handlerLoading({ loading: true, loadName: "get_estadisticas" });
  // handlerLoading({ loading: true, loadName: "estadisticas_vehiculos" });
  try {
    const response = await axios().get("/get_estadisticas_abonadas");
    // handlerLoading({ loading: false, loadName: "estadisticas" });
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "estadisticas_abonadas" });
    // handlerLoading({ loading: false, loadName: "get_estadisticas" });
    // handlerLoading({ loading: false, loadName: "estadisticas_vehiculos" });
  }
};
